import { isPlatformServer } from '@angular/common';
import {
  makeStateKey,
  TransferState,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import {
  ResolveFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { throwError } from 'rxjs';
import { ProviderNotFoundError } from './error-handler.service';

const PROVIDER_ERROR_KEY = makeStateKey<string>('resolved-provider-error');

export const notFoundResolverFn: ResolveFn<void> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const transferState = inject(TransferState);
  const platformId = inject(PLATFORM_ID);

  // Only set error key on server
  if (isPlatformServer(platformId)) {
    transferState.set(PROVIDER_ERROR_KEY, new ProviderNotFoundError().name);
    throwError(() => new ProviderNotFoundError());
  }
  return;
};
